// @flow
import { createContext } from 'react'
import type { ContextOptions } from './types'

export type MenuContextType = {
  options: ContextOptions,
}

const MenuContext = createContext<MenuContextType>({
  options: {},
})

export { MenuContext }
